import { client, secureClient } from "../../config/axiosClient";
import A12Y_CONST from '../../common/a12yConst'
import CONFIG from "../../config/apiConfig";

export const login = (username, password, authcode) => async (dispatch, getState) => {
    try {
        dispatch({ type: A12Y_CONST.DISPATCH_ACTION.LOGIN_START });

        let reqBody = Object.keys(authcode).length > 0
            ? authcode.invitation_uuid
                ? { auth_code: authcode.auth_code, invitation_uuid: authcode.invitation_uuid }
                : { auth_code: authcode.auth_code }
            : { username, password };

        const loginResponse = await client.post(A12Y_CONST.API_ENDPOINT.LOGIN, reqBody);

        if (!loginResponse.data.error && loginResponse.data.status === A12Y_CONST.API_RESPONSE_STATUS.OK) {
            const loginResInfo = loginResponse.data;

            let userInfoObj = loginResInfo.sr?.userInfo || {};
            userInfoObj.email = loginResInfo.sr?.cogResp?.email;
            userInfoObj.is_google_user = loginResInfo.sr?.cogResp?.is_google_user;
            userInfoObj.first_name = loginResInfo.sr?.cogResp?.first_name;
            userInfoObj.last_name = loginResInfo.sr?.cogResp?.last_name;

            let dispatchData = {
                access_token: loginResInfo.sr.cogResp.access_token,
                refresh_token: loginResInfo.sr.cogResp.refresh_token,
                id_token: loginResInfo.sr.cogResp.id_token,
                userInfo: userInfoObj
            };

            dispatch({
                type: A12Y_CONST.DISPATCH_ACTION.LOGIN_SUCCESS,
                userState: dispatchData
            });

            // Fetch detailed dependents
            const dependentsResponse = await secureClient.get(A12Y_CONST.API_ENDPOINT.GET_ADVOCATE_DEPENDENTS);
            const dependentsResInfo = dependentsResponse.data;
            const allDependents = dependentsResInfo.sr.dependents || [];
            const firstDependent = userInfoObj.user_type === 1
                ? (allDependents.find(d => d.status === 0 && !d.contact_advocate) || allDependents[0] || {})
                : (allDependents.find(d => d.status === 0) || allDependents[0] || {});
            // Dispatch dependents and related info
            dispatch({
                type: A12Y_CONST.DISPATCH_ACTION.GET_DEPENDENT_SUCCESS,
                dependents: dependentsResInfo.sr.dependents || [],
                dependent: firstDependent,
                message: dependentsResInfo.sr.message || ''
            });
            let filterDataMap = {};
            allDependents.forEach(dep => {
                let filterInfo = dep.reporting_period;
                let filterObj = {
                    "activity": { startDate: '', endDate: "", type: [], category_ids: [], isModify: false },
                    "expense": { startDate: "", endDate: "", type: [], reimbursable: null, isModify: false },
                    "income": { startDate: "", endDate: "", type: [], isModify: false },
                }

                filterObj['activity'].type = filterInfo?.activity_type_ids ? filterInfo.activity_type_ids : [];
                filterObj['activity'].category_ids = filterInfo?.category_ids ? filterInfo.category_ids : [];
                filterObj['activity'].startDate = filterInfo?.start_date ? filterInfo.start_date : "";
                filterObj['activity'].endDate = filterInfo?.end_date ? filterInfo.end_date : "";
                filterObj['expense'].type = filterInfo?.expense_type_ids ? filterInfo.expense_type_ids : [];
                filterObj['expense'].reimbursable = filterInfo?.reimbursable !== undefined ? filterInfo.reimbursable : null;
                filterObj['expense'].startDate = filterInfo?.start_date ? filterInfo.start_date : "";
                filterObj['expense'].endDate = filterInfo?.end_date ? filterInfo.end_date : "";
                filterObj['income'].type = filterInfo?.income_type_ids ? filterInfo.income_type_ids : [];
                filterObj['income'].startDate = filterInfo?.start_date ? filterInfo.start_date : "";
                filterObj['income'].endDate = filterInfo?.end_date ? filterInfo.end_date : "";

                filterDataMap[dep.id] = filterObj;
            });

            dispatch({
                type: A12Y_CONST.DISPATCH_ACTION.SELECTED_FILTERED,
                payload: { dataMap: filterDataMap }
            });

            dispatch({
                type: A12Y_CONST.DISPATCH_ACTION.UPDATE_META_DATA,
                income_present: firstDependent.metadata?.income_present || false,
                expense_present: firstDependent.metadata?.expense_present || false,
                activity_present: firstDependent.metadata?.activity_present || false,
                asset_present: firstDependent.metadata?.asset_present || false
            });

            dispatch({
                type: A12Y_CONST.DISPATCH_ACTION.UPDATE_MEDICINE_PRESENT_META_DATA,
                medicine_present: firstDependent.metadata?.medicine_present || false,
            })

            dispatch({
                type:A12Y_CONST.DISPATCH_ACTION.UPDATE_DOCTOR_PRESENT_META_DATA,
                doctor_present: firstDependent.metadata?.doctor_present || false
            })

            dispatch({
                type: A12Y_CONST.DISPATCH_ACTION.USER_SUBSCRIPTION_SUCCESS,
                userSubscription: firstDependent.subscirption?.subscription_details || {},
                userSubscriptionAllDetails: firstDependent.subscirption || {},
                paymentMethod: firstDependent.subscirption?.payment_method || {},
                userPlan: firstDependent.subscirption?.plan_name || null,
                subscriptionProduct: firstDependent.subscription_product || [],
                stripeConfig: loginResInfo.sr?.stripeConfig || {}
            });
            if (userInfoObj.user_type !== 1) {
                // Fetch subscription data explicitly
                try {
                    const subscriptionResponse = await secureClient.get(A12Y_CONST.API_ENDPOINT.SUBSCRIPTION);
                    if (!subscriptionResponse.data.error && subscriptionResponse.data.status === A12Y_CONST.API_RESPONSE_STATUS.OK) {
                        dispatch({
                            type: A12Y_CONST.DISPATCH_ACTION.GET_SUBSCRIPTION_SUCCESS,
                            subscription: subscriptionResponse.data.sr,
                            message: subscriptionResponse.data.sr?.message || ''
                        });
                    } else {
                        dispatch({
                            type: A12Y_CONST.DISPATCH_ACTION.GET_SUBSCRIPTION_ERROR,
                            errMsg: subscriptionResponse.data.sr?.a12yErr?.message || 'Error fetching subscription',
                            code: subscriptionResponse.data.sr?.a12yErr?.code || ''
                        });
                    }
                } catch (subErr) {
                    console.error('Error fetching subscription during login:', subErr);
                    dispatch({
                        type: A12Y_CONST.DISPATCH_ACTION.GET_SUBSCRIPTION_ERROR,
                        errMsg: subErr.message || 'Error fetching subscription',
                        code: ''
                    });
                }
            } else {
                dispatch({
                    type: A12Y_CONST.DISPATCH_ACTION.GET_SUBSCRIPTION_SUCCESS,
                    subscription: [],
                    message: ''
                });
            }

            // Return the dependent so handleSubmit can use it immediately
            return { firstDependent, userInfo: userInfoObj };
        } else {
            dispatch({
                type: A12Y_CONST.DISPATCH_ACTION.LOGIN_ERROR,
                errMsg: loginResponse.data.sr?.a12yErr?.message,
                code: loginResponse.data.sr?.a12yErr?.code
            });
            return { firstDependent: {} };
        }
    } catch (error) {
        await client.post(A12Y_CONST.API_ENDPOINT.REPORT_ERROR, {
            type: A12Y_CONST.ERROR_CODE.LOGIN,
            log: error
        });
        dispatch({
            type: A12Y_CONST.DISPATCH_ACTION.LOGIN_ERROR,
            errMsg: A12Y_CONST.ERROR_MESSAGE.UNEXPECTED_ERROR_MSG,
            code: ''
        });
        return { firstDependent: {} };
    }
};






export const signUp = (data) => async (dispatch, getState) => {
    try {
        dispatch({ type: A12Y_CONST.DISPATCH_ACTION.SIGNUP_START })

        const signUpResponse = await client.post(A12Y_CONST.API_ENDPOINT.SIGNUP, data);
        if (!signUpResponse.data.error && signUpResponse.data.status === A12Y_CONST.API_RESPONSE_STATUS.OK) {
            window.gtag('event', A12Y_CONST.GOOGLE_ANALYTIC_EVENT.SIGNUP_SUCCESS, {
                description: "Signup success.",
            });
            const signupResInfo = signUpResponse.data;
            let dispatchData = {
                userInfo: { username: signupResInfo.sr.cognitoResponse.username },
                usercognitoResponse: { cognitoResponse: signupResInfo.sr.cognitoResponse }
            }
            dispatch({
                type: A12Y_CONST.DISPATCH_ACTION.SIGNUP_SUCCESS,
                userState: dispatchData
            });
        } else {
            const signupResInfo = signUpResponse.data;
            dispatch({
                type: A12Y_CONST.DISPATCH_ACTION.SIGNUP_ERROR,
                errMsg: signupResInfo.sr.a12yErr.message,
                code: signupResInfo.sr.a12yErr.code,
            });
            window.gtag('event', A12Y_CONST.GOOGLE_ANALYTIC_EVENT.SIGNUP_FAILED, {
                description: signupResInfo.sr.a12yErr.message,
                email: data.email,
                fatal: false
            });
        }
    } catch (error) {
        await client.post(A12Y_CONST.API_ENDPOINT.REPORT_ERROR, {
            type: A12Y_CONST.ERROR_CODE.SIGNUP,
            log: error
        });
        dispatch({
            type: A12Y_CONST.DISPATCH_ACTION.SIGNUP_ERROR,
            errMsg: A12Y_CONST.ERROR_MESSAGE.UNEXPECTED_ERROR_MSG,
            code: '',
        });
        window.gtag('event', A12Y_CONST.GOOGLE_ANALYTIC_EVENT.SIGNUP_SS_ERROR, {
            description: error.message,
            fatal: true
        });
    }
}

export const updateUserProfile = (data, email) => async (dispatch, getState) => {
    try {
        dispatch({ type: A12Y_CONST.DISPATCH_ACTION.UPDATE_USER_PROFILE_START })

        const response = await secureClient.put(A12Y_CONST.API_ENDPOINT.UPDATE_PROFILE, data);
        if (!response.data.error && response.data.status === A12Y_CONST.API_RESPONSE_STATUS.OK) {
            window.gtag('event', 'advocate_profile_updated', {

            });
            const responseResInfo = response.data;
            responseResInfo.sr.userInfo.email = email
            let dispatchData = {
                userInfo: responseResInfo.sr.userInfo,

            }
            dispatch({
                type: A12Y_CONST.DISPATCH_ACTION.UPDATE_USER_PROFILE_SUCCESS,
                userInfo: dispatchData,
                message: responseResInfo.sr.message
            });
        } else {
            const responseResInfo = response.data;
            dispatch({
                type: A12Y_CONST.DISPATCH_ACTION.UPDATE_USER_PROFILE_ERROR,
                errMsg: responseResInfo.sr.a12yErr.message,
                code: responseResInfo.sr.a12yErr.code,
            });
            window.gtag('event', 'advocate_profile_update_failed', {
                description: responseResInfo.sr.a12yErr.message,
                fatal: false
            });
        }

    } catch (error) {
        await client.post(A12Y_CONST.API_ENDPOINT.REPORT_ERROR, {
            type: A12Y_CONST.ERROR_CODE.UPDATE_PROFILE,
            log: error
        });
        dispatch({
            type: A12Y_CONST.DISPATCH_ACTION.UPDATE_USER_PROFILE_ERROR,
            errMsg: A12Y_CONST.ERROR_MESSAGE.UNEXPECTED_ERROR_MSG,
            code: '',
        });
        window.gtag('event', 'exception', {
            description: "Unable to update profile.",
            fatal: true
        });
    }
}

export const updatePassword = (data) => async (dispatch, getState) => {
    try {
        dispatch({ type: A12Y_CONST.DISPATCH_ACTION.UPDATE_USER_PASSWORD_START })

        const response = await secureClient.post(A12Y_CONST.API_ENDPOINT.UPDATE_PASSWORD, data);
        if (!response.data.error && response.data.status === A12Y_CONST.API_RESPONSE_STATUS.OK) {
            window.gtag('event', 'password_updated', {

            });
            const responseResInfo = response.data;
            let dispatchData = {
                userInfo: responseResInfo.sr.userInfo,

            }
            dispatch({
                type: A12Y_CONST.DISPATCH_ACTION.UPDATE_USER_PASSWORD_SUCCESS,
                userInfo: dispatchData,
                message: responseResInfo.sr.message
            });
        } else {
            const responseResInfo = response.data;
            dispatch({
                type: A12Y_CONST.DISPATCH_ACTION.UPDATE_USER_PASSWORD_ERROR,
                errMsg: responseResInfo.sr.a12yErr.message,
                code: responseResInfo.sr.a12yErr.code,
            });
            window.gtag('event', 'password_update_failed', {
                description: responseResInfo.sr.a12yErr.message
            });
        }
    } catch (error) {
        await client.post(A12Y_CONST.API_ENDPOINT.REPORT_ERROR, {
            type: A12Y_CONST.ERROR_CODE.UPDATE_PASSWORD,
            log: error
        });
        dispatch({
            type: A12Y_CONST.DISPATCH_ACTION.UPDATE_USER_PASSWORD_ERROR,
            errMsg: A12Y_CONST.ERROR_MESSAGE.UNEXPECTED_ERROR_MSG,
            code: '',
        });
        window.gtag('event', 'exception', {
            description: "Unable to update password",
            fatal: true
        });
    }
}

export const createUserSubscription = (data) => async (dispatch, getState) => {
    dispatch({ type: A12Y_CONST.DISPATCH_ACTION.CREATE_USER_SUBSCRIPTION_START })
    const response = await secureClient.post(A12Y_CONST.API_ENDPOINT.CREATE_SUBSCRIPTION_WITH_PAYMENT, data);
    if (!response.data.error && response.data.status === A12Y_CONST.API_RESPONSE_STATUS.OK) {
        window.gtag('event', 'subscription_created', {

        });
        window.gtag('event', 'conversion', { 'send_to': CONFIG.GOOGLE_TRACKING_ID2, 'transaction_id': '' });
        const responseResInfo = response.data;
        dispatch({
            type: A12Y_CONST.DISPATCH_ACTION.CREATE_USER_SUBSCRIPTION_SUCCESS,
            userSubscription: responseResInfo.sr.userSubscription,
            paymentMethod: responseResInfo.sr.paymentMethod,
            userPlan: responseResInfo.sr.userPlan,
            message: responseResInfo.sr.message
        });
    } else {
        const responseResInfo = response.data;
        dispatch({
            type: A12Y_CONST.DISPATCH_ACTION.CREATE_USER_SUBSCRIPTION_ERROR,
            errMsg: responseResInfo.sr.a12yErr.message,
            code: responseResInfo.sr.a12yErr.code,
        });
        window.gtag('event', 'subscription_creation_failed', {
            description: responseResInfo.sr.a12yErr.message
        });
    }
}

export const updatePaymentMethod = (data) => async (dispatch, getState) => {
    dispatch({ type: A12Y_CONST.DISPATCH_ACTION.UPDATE_PAYMENT_METHOD_START })
    const response = await secureClient.post(A12Y_CONST.API_ENDPOINT.UPDATE_PAYMENT_METHOD, data);
    if (!response.data.error && response.data.status === A12Y_CONST.API_RESPONSE_STATUS.OK) {
        window.gtag('event', 'subscription_created', {

        });
        const responseResInfo = response.data;
        dispatch({
            type: A12Y_CONST.DISPATCH_ACTION.UPDATE_PAYMENT_METHOD_SUCCESS,
            userSubscription: responseResInfo.sr.subscription?.[0] || responseResInfo.sr.user_subscirption?.subscription_details,
            subscription: responseResInfo.sr.subscription,
            paymentMethod: responseResInfo.sr.subscription?.[0]?.payment_method || responseResInfo.sr.paymentMethod,
            planName: responseResInfo.sr.subscription?.[0]?.items?.[0]?.plan_name || responseResInfo.sr.plan_name,
            message: responseResInfo.sr.message,
            price_details: responseResInfo.sr.subscription?.[0]?.price_details || responseResInfo.sr.user_subscirption?.price_details,
            firstTimeSubscription: responseResInfo.sr?.first_time_subscription !== undefined || responseResInfo.sr?.payment_method_updated !== undefined
                ? { first_time_subscription: responseResInfo.sr.first_time_subscription, payment_method_updated: responseResInfo.sr.payment_method_updated }
                : null,
        });
    } else {
        const responseResInfo = response.data;
        dispatch({
            type: A12Y_CONST.DISPATCH_ACTION.UPDATE_PAYMENT_METHOD_ERROR,
            errMsg: responseResInfo.sr.a12yErr.message,
            code: responseResInfo.sr.a12yErr.code,
        });
        window.gtag('event', 'subscription_creation_failed', {
            description: responseResInfo.sr.a12yErr.message
        });
    }
}


export const cancelUserSubscription = (data) => async (dispatch, getState) => {
    dispatch({ type: A12Y_CONST.DISPATCH_ACTION.CANCEL_SUBSCRIPTION_START })
    const response = await secureClient.put(A12Y_CONST.API_ENDPOINT.CANCEL_SUBSCRIPTION, data);
    if (!response.data.error && response.data.status === A12Y_CONST.API_RESPONSE_STATUS.OK) {
        window.gtag('event', 'subscription_cancelled', {

        });
        const responseResInfo = response.data;
        dispatch({
            type: A12Y_CONST.DISPATCH_ACTION.CANCEL_SUBSCRIPTION_SUCCESS,
            userSubscription: responseResInfo.sr.userSubscription,
            paymentMethod: responseResInfo.sr.paymentMethod,
            message: responseResInfo.sr.message
        });
        return { success: true, message: responseResInfo.sr.message };
    } else {
        const responseResInfo = response.data;
        dispatch({
            type: A12Y_CONST.DISPATCH_ACTION.CANCEL_SUBSCRIPTION_ERROR,
            errMsg: responseResInfo.sr.a12yErr.message,
            code: responseResInfo.sr.a12yErr.code,
        });
        window.gtag('event', 'subscription_cancel_failed', {
            description: responseResInfo.sr.a12yErr.message
        });
        return { success: false, errMsg: responseResInfo.sr.a12yErr.message };
    }
}

export const getSubscription = () => async (dispatch, getState) => {
    if (getState().userDetailReducer.userState?.userInfo?.user_type === 1) {
        return;
    }
    dispatch({ type: A12Y_CONST.DISPATCH_ACTION.GET_SUBSCRIPTION_START })
    const response = await secureClient.get(A12Y_CONST.API_ENDPOINT.SUBSCRIPTION);
    if (!response.data.error && response.data.status === A12Y_CONST.API_RESPONSE_STATUS.OK) {
        const responseResInfo = response.data;
        dispatch({
            type: A12Y_CONST.DISPATCH_ACTION.GET_SUBSCRIPTION_SUCCESS,
            subscription: responseResInfo.sr,
            message: responseResInfo.sr.message
        });
    } else {
        const responseResInfo = response.data;
        dispatch({
            type: A12Y_CONST.DISPATCH_ACTION.GET_SUBSCRIPTION_ERROR,
            errMsg: responseResInfo.sr.a12yErr.message,
            code: responseResInfo.sr.a12yErr.code,
        });
    }
}

export const getProration = () => async (dispatch, getState) => {
    if (getState().userDetailReducer.userState?.userInfo?.user_type === 1) {
        return;
    }
    dispatch({ type: A12Y_CONST.DISPATCH_ACTION.GET_PRORATION_START })
    try {
        const response = await secureClient.get(A12Y_CONST.API_ENDPOINT.GET_PRORATION);
        if (!response.data.error && response.data.status === A12Y_CONST.API_RESPONSE_STATUS.OK) {
            const responseResInfo = response.data;
            const fee = parseInt(responseResInfo.sr.activation_fee || "4900", 10);
            dispatch({
                type: A12Y_CONST.DISPATCH_ACTION.GET_PRORATION_SUCCESS,
                proratedAmount: responseResInfo.sr.prorated_amount || 0,
                nextBill: responseResInfo.sr.next_bill || 0,
                activationFee: !isNaN(fee) ? (fee / 100).toString() : null,
                excemptAllFee: responseResInfo.sr.excempt_all_fee || false
            });
            return { success: true };
        } else {
            const responseResInfo = response.data;
            const errMsg = responseResInfo.sr?.a12yErr?.message || responseResInfo.a12yErr?.message || "Unable to calculate proration!";
            dispatch({
                type: A12Y_CONST.DISPATCH_ACTION.GET_PRORATION_ERROR,
                errMsg: errMsg,
                code: responseResInfo.sr?.a12yErr?.code || '',
            });
            return { success: false, errMsg: errMsg };
        }
    } catch (error) {
        const errMsg = error.response?.data?.sr?.a12yErr?.message || error.response?.data?.a12yErr?.message || error.message || "Unable to calculate proration!";
        dispatch({
            type: A12Y_CONST.DISPATCH_ACTION.GET_PRORATION_ERROR,
            errMsg: errMsg,
        });
        return { success: false, errMsg: errMsg };
    }
}

export const getDependentEventLogs = () => async (dispatch, getState) => {
    if (getState().userDetailReducer.userState?.userInfo?.user_type === 1) {
        return;
    }
    dispatch({ type: A12Y_CONST.DISPATCH_ACTION.GET_DEPENDENT_EVENT_LOGS_START });
    try {
        const response = await secureClient.get(A12Y_CONST.API_ENDPOINT.DEPENDENT_EVENT_LOGS);
        if (!response.data.error && response.data.status === A12Y_CONST.API_RESPONSE_STATUS.OK) {
            dispatch({
                type: A12Y_CONST.DISPATCH_ACTION.GET_DEPENDENT_EVENT_LOGS_SUCCESS,
                eventLogs: response.data.sr || [],
            });
        } else {
            dispatch({
                type: A12Y_CONST.DISPATCH_ACTION.GET_DEPENDENT_EVENT_LOGS_ERROR,
                errMsg: response.data.sr?.a12yErr?.message || 'Failed to load event logs',
            });
        }
    } catch (error) {
        dispatch({
            type: A12Y_CONST.DISPATCH_ACTION.GET_DEPENDENT_EVENT_LOGS_ERROR,
            errMsg: error.message,
        });
    }
}

export const logoutUser = () => (dispatch, getState) => {
    sessionStorage.removeItem('hasDismissedDashboardPopUp');
    dispatch({ type: A12Y_CONST.DISPATCH_ACTION.LOGOUT, payload: {} })
}

export const dataChanged = (status) => async (dispatch, getState) => {
    dispatch({ type: A12Y_CONST.DISPATCH_ACTION.IS_FIELD_UPDATED, payload: { status: status } })
}

export const updateSessionTimeout = (status) => async (dispatch, getState) => {
    dispatch({ type: A12Y_CONST.DISPATCH_ACTION.UPDATE_SESSION_TIMEOUT, payload: { isSessionTimeout: status } })
}

export const sendErrorReportToServer = (type, error) => async (dispatch, getState) => {
    await client.post(A12Y_CONST.API_ENDPOINT.REPORT_ERROR, {
        type: type,
        log: error
    });
}

export const selectUserRoleType = (type) => async (dispatch, getState) => {
    dispatch({ type: A12Y_CONST.DISPATCH_ACTION.USER_ROLE_TYPE, payload: { type: type } })
}

export const signUpTextChange = (data) => async (dispatch, getState) => {
    dispatch({ type: A12Y_CONST.DISPATCH_ACTION.SIGNUP_TEXT, payload: { type: data } })
}

export const trialReminder = (status) => async (dispatch, getState) => {
    dispatch({ type: A12Y_CONST.DISPATCH_ACTION.IS_TRIAL_REMINDER, payload: { status: status } })
}

export const welcomePopUp = (status) => async (dispatch, getState) => {
    dispatch({ type: A12Y_CONST.DISPATCH_ACTION.IS_WELCOME_POPUP, payload: { status: status } })
}

export const surveyRolePopUp = (status) => async (dispatch, getState) => {
    dispatch({ type: A12Y_CONST.DISPATCH_ACTION.IS_SURVEY_ROLE_POPUP, payload: { status: status } })
}

export const surveyPopUp = (status) => async (dispatch, getState) => {
    dispatch({ type: A12Y_CONST.DISPATCH_ACTION.IS_SURVEY_POPUP, payload: { status: status } })
}

export const goToBillingScreen = (status) => async (dispatch, getState) => {
    dispatch({ type: A12Y_CONST.DISPATCH_ACTION.BILLING_SCREEN, payload: { status: status } })
}

export const setInviteCode = (data) => async (dispatch, getState) => {
    dispatch({ type: A12Y_CONST.DISPATCH_ACTION.INVITE_CODE, payload: { type: data } })
}

export const setLogoutPopStatus = (status) => async (dispatch, getState) => {
    dispatch({ type: A12Y_CONST.DISPATCH_ACTION.SET_LOGOUT_POPUP_STATUS, payload: { status: status } })
}

export const selectedFilterTypeList = (data) => async (dispatch, getState) => {
    dispatch({ type: A12Y_CONST.DISPATCH_ACTION.SELECTED_FILLTER_TYPE_LIST, payload: { type: data } })
}

export const selectedFilterTypeListIncome = (data) => async (dispatch, getState) => {
    dispatch({ type: A12Y_CONST.DISPATCH_ACTION.SELECTED_FILLTER_TYPE_LIST_INCOME, payload: { type: data } })
}

export const setSeletedFilter = (data) => async (dispatch, getState) => {
    const dependentId = getState().dependentReducer.dependent?.id;
    dispatch({ type: A12Y_CONST.DISPATCH_ACTION.SELECTED_FILTERED, payload: { dependentId, data } })
}

export const userSubscriptionDetailUpdate = (data) => async (dispatch, getState) => {
    dispatch({ type: A12Y_CONST.DISPATCH_ACTION.USER_SUBSCRIPTION_DETAIL_UPDATE, payload: { data: data } })
}


// export const setLoginSource = (data) => async(dispatch, getState) =>{
//     dispatch({type: A12Y_CONST.DISPATCH_ACTION.USER_SOURCE_LOGIN, payload: {type:data}})
// }
